export enum VacationStatus {
  Requested = 0,
  Approved = 1,
  Declined = 2
}
